import React, { useState, useEffect } from "react";
import { baseUrl } from "../../common/constants";
import _axios from "../../utils/api/_axios";
import { LoaderCircle, Pencil, Trash2 } from "lucide-react";
import DoctorsManagement from "../Physician/DoctorsManagement";
import { Select } from "antd";
import { toast } from "react-toastify";
import ButtonLoader from "../../components/ReusableElements/Button/ButtonLoader";

const { Option } = Select;
const HospitalManagement = () => {
  const [hospitals, setHospitals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tempPhone, setTempPhone] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [serviceCosts, setServiceCosts] = useState({});
  const [services, setServices] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [doctorEditMode,setDoctorEditMode] = useState(false);
  const [networkLoading, setNetworkLoading] = useState(false);
  const [newHospital, setNewHospital] = useState({
    hospitalName: "",
    hospitalAddress1: "",
    hospitalAddress2: "",
    hospitalEmail: "",
    hospitalServices: "",
    hospitalPhone: "",
    hospitalCity: "",
    hospitalState: "",
    hospitalZip: "",
    hospitalFax: "",
    hospitalNPI: "",
    hospitalType: "",
    hospitalMainContactFirstName: "",
    hospitalMainContactLastName: "",
    hospitalMainContactEmail: "",
    hospitalMainContactPhone: "",
    hospitalAccountingContactFirstName: "",
    hospitalAccountingContactLastName: "",
    hospitalAccountingContactEmail: "",
    hospitalAccountingContactPhone: "",
  });

  const validateForm = () => {
    let tempErrors = {};
    Object.keys(newHospital).forEach((key) => {
      if (!newHospital[key].trim()) {
        tempErrors[key] = `${key.replace(/hospital|MainContact|AccountingContact/g, "")} is required`;
      }
    });
  
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  
  const [showDoctorModal, setShowDoctorModal] = useState(false);
  const [newDoctor, setNewDoctor] = useState({
    name: "",
    specialization: "",
    email: "",
  });
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [doctors, setDoctors] = useState([]); // Store doctors
  const [doctorAssociatedWithHospital, setDoctorAssociatedWithHospital] = useState([]); // Store doctors associated with the selected hospital
  const [selectedDoctorId, setSelectedDoctorId] = useState(null); // Store selected doctor ID
  const [selectedDoctorDetails, setSelectedDoctorDetails] = useState(null); // Store full details of selected doctor
  const [editFormData, setEditFormData] = useState({
    hospitalName: "",
    hospitalAddress1: "",
    hospitalAddress2: "",
    hospitalEmail: "",
    hospitalServices: "",
    hospitalPhone: "",
    hospitalCity: "",
    hospitalState: "",
    hospitalZip: "",
    hospitalFax: "",
    hospitalNPI: "",
    hospitalType: "",
    hospitalMainContactFirstName: "",
    hospitalMainContactLastName: "",
    hospitalMainContactEmail: "",
    hospitalMainContactPhone: "",
    hospitalAccountingContactFirstName: "",
    hospitalAccountingContactLastName: "",
    hospitalAccountingContactEmail: "",
    hospitalAccountingContactPhone: "",
  });

  async function initialFetching() {
    const response = await _axios.get(`${baseUrl}/hospital/get-all/`);
    setHospitals(response?.data?.payload);
    setSelectedHospital(response?.data?.payload[0] || null);
    fetchUpdatedHospital(response?.data?.payload[0]?._id);
  }
  useEffect(() => {
    setLoading(true);
    initialFetching();
    setLoading(false);
  }, []);

  useEffect(() => {
    _axios
      .get(`${baseUrl}/physician/get-all`)
      .then((response) => {
        setDoctors(response.data.payload);
      })
      .catch((error) => console.error("Error fetching doctors:", error));
  }, []);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await _axios.get(`${baseUrl}/servicePerformed/get-all`);
      setServices(response.data.payload);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const handleAddHospital = () => {
    setShowModal(true);
  };

  const handleSubmitHospital = async (e) => {
    e.preventDefault();
    // if (!validateForm()) return;
    setNetworkLoading(true);
    try {
      const response = await _axios.post(`${baseUrl}/hospital`, newHospital, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.status === 201 || response.status === 200) {
        toast.success("Hospital added successfully");
        setNewHospital({
          hospitalName: "",
          hospitalAddress1: "",
          hospitalAddress2: "",
          hospitalCity: "",
          hospitalState: "",
          hospitalZip: "",
          hospitalEmail: "",
          hospitalPhone: "",
          hospitalFax: "",
          hospitalNPI: "",
          hospitalType: "",
          hospitalMainContactFirstName: "",
          hospitalMainContactLastName: "",
          hospitalMainContactEmail: "",
          hospitalMainContactPhone: "",
          hospitalAccountingContactFirstName: "",
          hospitalAccountingContactLastName: "",
          hospitalAccountingContactEmail: "",
          hospitalAccountingContactPhone: "",
        });
        initialFetching();
        setShowModal(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.metadata?.errorMessage || "Error adding hospital");
      console.error("Error adding hospital:", error);
    }
    finally{
      setNetworkLoading(false);
    }
  };
  

  const handleAddDoctor = (doctorId) => {
    if(doctorId) {
      const doctor = doctors.find((doc) => doc._id === doctorId);
      setSelectedDoctorId(doctorId);
      setSelectedDoctorDetails(doctor || null);
    }
    setShowDoctorModal(true);
  }
  const fetchUpdatedHospital = async (hospitalId) => {
    try {
      const response = await _axios.get(`${baseUrl}/hospitalPhysician/hospital/${hospitalId}`);
      const updatedHospital = response.data.payload;
      // Update hospitals list in state
      setDoctorAssociatedWithHospital(updatedHospital)
  
      // Update selected hospital
      // setSelectedHospital(updatedHospital);
    } catch (error) {
      console.error("Error fetching updated hospital:", error);
    }
  };

const handleSubmitDoctor = async () => {
  if (!selectedDoctorId || selectedServices.length === 0) return;

  const newHospitalPhysician = {
    hospitalId: selectedHospital._id,
    doctorId: selectedDoctorId,
    ServicesList: selectedServices.map((serviceId) => ({
      serviceId,
      serviceName: services.find((s) => s._id === serviceId)?.serviceName || "",
      serviceFee: Number(serviceCosts[serviceId]) || 0,
    })),
  };

  try {
    let response;
    setNetworkLoading(true);
    if (doctorEditMode) {
      response = await _axios.put(
        `${baseUrl}/hospitalPhysician/physician/update/${selectedDoctorId}`,
        newHospitalPhysician,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
    } else {
      response = await _axios.post(
        `${baseUrl}/hospitalPhysician`,
        newHospitalPhysician,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
    }
    setNetworkLoading(false);
    if (response.status === 201 || response.status === 200) {
      toast.success("doctor operation successful")
      fetchUpdatedHospital(selectedHospital?._id);
      handleCloseDoctorModal();
    }
  } catch (error) {
    setNetworkLoading(false);
    toast.error(error?.response?.data?.metadata?.errorMessage);
  }
};

  const handleDelete = async (hospitalId) => {
    if (!window.confirm("Are you sure you want to delete this hospital?"))
      return;

    try {
      const response = await _axios.delete(`${baseUrl}/hospital/${hospitalId}`);
      if(response?.status === 200 || response.status === 201){
        toast.success("Hospital deleted successfully");
        setHospitals(hospitals.filter((hospital) => hospital._id !== hospitalId));
      }
    } catch (error) {
      toast.error("Error deleting hospital");
      console.error("Error deleting hospital:", error);
    }
  };

  // Handle Edit - Open Modal with Existing Data
  const handleEdit = (hospital) => {
    setEditFormData({
      hospitalName: hospital.hospitalName,
      hospitalAddress1: hospital.hospitalAddress1,
      hospitalAddress2: hospital.hospitalAddress2,
      hospitalEmail: hospital.hospitalEmail,
      hospitalServices: hospital.hospitalServices,
      hospitalPhone: hospital.hospitalPhone,
      hospitalCity: hospital.hospitalCity,
      hospitalState: hospital.hospitalState,
      hospitalZip:  hospital.hospitalZip,
      hospitalFax: hospital.hospitalFax,
      hospitalNPI: hospital.hospitalNPI,
      hospitalType: hospital.hospitalType,
      hospitalMainContactFirstName: hospital.hospitalMainContactFirstName,
      hospitalMainContactLastName: hospital.hospitalMainContactLastName,
      hospitalMainContactEmail: hospital.hospitalMainContactEmail,
      hospitalMainContactPhone: hospital.hospitalMainContactPhone,
      hospitalAccountingContactFirstName:
        hospital.hospitalAccountingContactFirstName,
      hospitalAccountingContactLastName:
        hospital.hospitalAccountingContactLastName,
      hospitalAccountingContactEmail: hospital.hospitalAccountingContactEmail,
      hospitalAccountingContactPhone: hospital.hospitalAccountingContactPhone,
    });
    setSelectedHospital(hospital);
    setEditModalOpen(true);
  };

  // Handle Save Edit
  const handleSaveEdit = async () => {
    if (!selectedHospital) return;

    try {
      setNetworkLoading(true);
      const response = await _axios.put(
        `${baseUrl}/hospital/${selectedHospital._id}`,
        editFormData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setNetworkLoading(false);
      if (response.status === 200 || response.status === 201) {
        toast.success("hospital edited successfully")
        initialFetching();
        setEditModalOpen(false); // Close modal
      }
    } catch (error) {
      console.error("Error updating hospital:", error);
      toast.error("network request failed")
    }
  };

  // Handle Change in Edit Form
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,  // Ensure the field updates properly
    }));
  };
  
const handlePhoneChange = (e, setFunction, field) => {
  let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
  if (value.length > 10) value = value.slice(0, 10); // Limit to 10 digits

  let formattedValue = value;
  if (value.length > 6) {
    formattedValue = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
  } else if (value.length > 3) {
    formattedValue = `${value.slice(0, 3)}-${value.slice(3)}`;
  }

  setFunction(prev => ({
    ...prev,
    [field]: formattedValue
  }));
};
  
  const handleDoctorChange = (doctorId) => {
    setSelectedDoctorId(doctorId);

    // Find the selected doctor details
    const doctor = doctors.find((doc) => doc._id === doctorId);
    setSelectedDoctorDetails(doctor || null);
  };

  const handleServiceChange = (selectedServiceIds) => {
    setSelectedServices(selectedServiceIds);
    
    // Keep existing costs for remaining services
    const updatedCosts = {};
    selectedServiceIds.forEach(id => {
      updatedCosts[id] = serviceCosts[id] || 0;
    });
    setServiceCosts(updatedCosts);
  };
  

const handleServiceCostChange = (serviceId, cost) => {
  const numericValue = parseFloat(cost) || 0;
  setServiceCosts(prev => ({
    ...prev,
    [serviceId]: numericValue
  }));
};

const handleCloseDoctorModal = () => {
  setShowDoctorModal(false);
  setSelectedDoctorDetails(null);
  setSelectedServices([]);
  setServiceCosts({});
  setDoctorEditMode(false);
  setSelectedDoctorId(null);
};

const handleEditDoctor = (doctor) => {
  // Clear previous states first
  setSelectedServices([]);
  setServiceCosts({});
  setSelectedDoctorId(null);
  setSelectedDoctorDetails(null);

  // Set new states
  setDoctorEditMode(true);
  setSelectedDoctorId(doctor.doctorDetails._id);
  setSelectedDoctorDetails(doctor.doctorDetails);
  
  // Map services and costs
  const selectedServiceIds = doctor.ServicesList.map(service => service.serviceId);
  const initialCosts = {};
  doctor.ServicesList.forEach(service => {
    initialCosts[service.serviceId] = service.serviceFee;
  });

  // Update states
  setSelectedServices(selectedServiceIds);
  setServiceCosts(initialCosts);
  setShowDoctorModal(true);
};

  const handleDeleteDoctor = async (doctor) => {
    if (!window.confirm("Are you sure you want to remove this doctor from the hospital?")) {
      return;
    }
    try {
     const response = await _axios.delete(`${baseUrl}/hospitalPhysician/delete/${doctor?.doctorId}`, {
        data: { hospitalId: selectedHospital._id }
    });
    if(response?.status === 200 || response.status === 201){
      toast.success("doctor deleted from this hospital");
      fetchUpdatedHospital(selectedHospital._id);
    }
      // Refresh the doctors list after successful deletion
    } catch (error) {
      console.error("Error deleting doctor:", error);
    }
  };

  if (loading) {
    return <div className="text-center p-5">Loading hospitals...</div>;
  }
  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <nav className="bg-white shadow-md p-4 flex justify-between items-center fixed top-0 left-[70px] w-[calc(100%-100px)] z-10">
        <h1 className="text-2xl font-bold">Facility Management</h1>
        <button
          className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-400"
          onClick={handleAddHospital}
        >
          + Add Facility
        </button>
      </nav>

      <div className="flex flex-grow p-5 mt-16">
        <aside className="w-1/4 bg-white shadow-md p-4 rounded-lg">
          <ul>
            {hospitals?.length > 0 ? hospitals?.map((hospital) => (
              <li
                key={hospital._id}
                className={`p-4 border-b border-gray-200 last:border-b-0 -mx-4 px-4 cursor-pointer flex justify-between items-center ${
                  selectedHospital?._id === hospital._id ? "bg-blue-100" : ""
                }`}
                onClick={() =>{
                  fetchUpdatedHospital(hospital._id);
                  setSelectedHospital({
                    ...hospital,
                    doctors: hospital.doctors || [],
                  })
                }
              }
              >
                {/* Left Side - Hospital Details */}
                <div>
                  <h3 className="font-semibold">{hospital.hospitalName}</h3>
                  <p className="text-xs text-gray-500">
                    📍 {hospital.hospitalAddress1}
                  </p>
                  {/* <span
                    className={`${
                      categoryColors[hospital.hospitalType] ||
                      "bg-gray-200 text-gray-800"
                    } text-xs font-semibold px-2 py-1 rounded-full inline-block mt-2`}
                  >
                    {hospital.hospitalType}
                  </span> */}
                </div>

                {/* Right Side - Edit & Delete Buttons */}
                <div className="flex gap-2">
                  {/* Edit Button */}
                  <button
                    className="p-2 rounded-md hover:bg-gray-100"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering hospital selection
                      handleEdit(hospital);
                    }}
                  >
                    <Pencil size={18} className="text-blue-500" />
                  </button>

                  {/* Delete Button */}
                  <button
                    className="p-2 rounded-md hover:bg-gray-100"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering hospital selection
                      handleDelete(hospital._id);
                    }}
                  >
                    <Trash2 size={18} className="text-red-500" />
                  </button>
                </div>
              </li>
            )):
            <div>No facility available</div>
            }
          </ul>
        </aside>

                <div className="w-3/4 ml-5 bg-white p-6 rounded-xl shadow-lg border border-gray-200">
          {selectedHospital && (
            <>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                {selectedHospital.hospitalName}
              </h2>
              <p className="text-gray-600 text-sm mb-1">{selectedHospital.hospitalAddress1}</p>
              <p className="text-gray-600 text-sm">City: <span className="font-medium">{selectedHospital.hospitalCity}</span></p>
              <p className="text-gray-600 text-sm">Zip: <span className="font-medium">{selectedHospital.hospitalZip}</span></p>
              <p className="text-gray-600 text-sm">Phone: <span className="font-medium">{selectedHospital.hospitalPhone}</span></p>
              <p className="text-gray-600 text-sm">Email: <span className="font-medium">{selectedHospital.hospitalEmail}</span></p>
              <p className="text-gray-600 text-sm">Fax: <span className="font-medium">{selectedHospital.hospitalFax}</span></p>
              <p className="text-gray-600 text-sm">NPI#: <span className="font-medium">{selectedHospital.hospitalNPI}</span></p>

              <h3 className="text-lg font-semibold mt-6 text-gray-800 border-b pb-1">Main Contact</h3>
              <p className="text-gray-600 text-sm">{selectedHospital.hospitalMainContactFirstName} {selectedHospital.hospitalMainContactLastName}</p>
              <p className="text-gray-600 text-sm">Email: <span className="font-medium">{selectedHospital.hospitalMainContactEmail}</span></p>
              <p className="text-gray-600 text-sm">Phone: <span className="font-medium">{selectedHospital.hospitalMainContactPhone}</span></p>

              <h3 className="text-lg font-semibold mt-6 text-gray-800 border-b pb-1">Accounting Contact</h3>
              <p className="text-gray-600 text-sm">{selectedHospital.hospitalAccountingContactFirstName} {selectedHospital.hospitalAccountingContactLastName}</p>
              <p className="text-gray-600 text-sm">Email: <span className="font-medium">{selectedHospital.hospitalAccountingContactEmail}</span></p>
              <p className="text-gray-600 text-sm">Phone: <span className="font-medium">{selectedHospital.hospitalAccountingContactPhone}</span></p>

              <div className="flex justify-between items-center mt-6 bg-gray-100 p-3 rounded-md">
                <h3 className="text-lg font-semibold text-gray-800">
                  Doctors in {selectedHospital.hospitalName}
                </h3>
                <button
                  className="bg-gray-700 text-white px-4 py-2 rounded-md hover:bg-gray-500 transition"
                  onClick={handleAddDoctor}
                >
                  + Add Doctor
                </button>
              </div>

              {Array.isArray(doctorAssociatedWithHospital) && doctorAssociatedWithHospital.length > 0 ? (
  <table className="w-full border-collapse border border-gray-200 mt-2">
    <thead>
      <tr className="bg-gray-100">
        <th className="border border-gray-300 p-2">Doctor Name</th>
        <th className="border border-gray-300 p-2">Services</th>
        <th className="border border-gray-300 p-2">Fees</th>
        <th className="border border-gray-300 p-2">operations</th>
      </tr>
    </thead>
    <tbody>
      {doctorAssociatedWithHospital.map((doctor, index) => (
        <tr key={index} className="text-center">
          {/* Doctor Name */}
          <td className="border border-gray-300 p-2">
            {doctor.doctorDetails?.physicianPrefix} {doctor?.doctorDetails?.physicianFirstName} {doctor?.doctorDetails?.physicianLastName}
          </td>

          {/* Services List */}
          <td className="border border-gray-300 p-2">
            {doctor.ServicesList && doctor.ServicesList.length > 0 ? (
              doctor.ServicesList.map((service, sIndex) => (
                <div key={sIndex} className="text-sm">
                  {service.serviceName}
                </div>
              ))
            ) : (
              <span className="text-gray-500">No Services</span>
            )}
          </td>

          {/* Fees List */}
          <td className="border border-gray-300 p-2">
            {doctor.ServicesList && doctor.ServicesList.length > 0 ? (
              doctor.ServicesList.map((service, sIndex) => (
                <div key={sIndex} className="text-sm">
                  ${service.serviceFee.toFixed(2)}
                </div>
              ))
            ) : (
              <span className="text-gray-500">N/A</span>
            )}
          </td>
          <td className="border border-gray-300 p-2">
          <div className="flex gap-2">
                  {/* Edit Button */}
                  <button
                    className="p-2 rounded-md hover:bg-gray-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditDoctor(doctor);
                      setDoctorEditMode(true);
                      setShowDoctorModal(true);
                    }}
                  >
                    <Pencil size={18} className="text-blue-500" />
                  </button>

                  {/* Delete Button */}
                  <button
                    className="p-2 rounded-md hover:bg-gray-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteDoctor(doctor);
                    }}
                  >
                    <Trash2 size={18} className="text-red-500" />
                  </button>
                </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
) : (
  <p className="text-gray-500 mt-2">No doctors available.</p>
)}



            </>

            
          )}
        </div>


      </div>

      {showDoctorModal && (
  <div className="fixed inset-0 bg-opacity-40 backdrop-blur-md flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
      <h2 className="text-lg font-bold mb-4">Add New Doctor</h2>
      {/* Doctor Selection Dropdown */}
      <Select
        showSearch
        placeholder="--Select Doctor--"
        size="large"
        className="fullWidth"
        onChange={handleDoctorChange}
        filterOption={(input, option) =>
          option.children.toLowerCase().includes(input.toLowerCase())
        }
      >
        <Option key="0" value="">
          --Select Doctor--
        </Option>
        {doctors.length > 0 &&
          doctors.map((doctor) => (
            <Option key={doctor._id} value={doctor._id}>
              {`${doctor.physicianPrefix} ${doctor.physicianFirstName} ${doctor.physicianLastName}`}
            </Option>
          ))}
      </Select>

      {/* Display Selected Doctor Details */}
      {selectedDoctorDetails && (
        <div className="bg-gray-100 p-4 rounded mt-4 shadow">
          <h3 className="text-lg font-semibold">{`${selectedDoctorDetails.physicianPrefix} ${selectedDoctorDetails.physicianFirstName} ${selectedDoctorDetails.physicianLastName}`}</h3>
          <p>
            <strong>Email:</strong> {selectedDoctorDetails.physicianEmail}
          </p>
          <p>
            <strong>Phone:</strong> {selectedDoctorDetails.physicianPhone}
          </p>
          <p>
            <strong>Specialization:</strong> {selectedDoctorDetails.specialization}
          </p>
          <p>
            <strong>NPI:</strong> {selectedDoctorDetails.physicianNPI}
          </p>
          <p>
            <strong>License:</strong> {selectedDoctorDetails.physicianLicense}
          </p>
          <p>
            <strong>Workers' Comp Authorization:</strong> {selectedDoctorDetails.physicianWCAuthorization}
          </p>
        </div>
      )}

      {/* Service Selection Multi-Select Dropdown with Cost Input */}
      <div className="mt-4">
        <h3 className="text-lg font-semibold mb-2">Select Services</h3>
        <Select
          mode="multiple"
          showSearch
          placeholder="--Select Services--"
          size="large"
          className="fullWidth"
          value={selectedServices} // Add this to maintain selected values
          onChange={handleServiceChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {services && services.length > 0 ? (
            services.map((service) => (
              <Option key={service._id} value={service._id}>
                {service.serviceName}
              </Option>
            ))
          ) : (
            <Option disabled>No services available</Option>
          )}
        </Select>

        {/* Cost Input Field for Each Selected Service */}
        {selectedServices.length > 0 && (
          <div className="mt-4">
            <h3 className="text-lg font-semibold mb-2">Define Service Costs</h3>
            {selectedServices.map((serviceId) => {
              const service = services.find((s) => s._id === serviceId);
              return (
                <div key={serviceId} className="flex items-center gap-2 mt-2">
                  <span className="w-1/2">{service?.serviceName}</span>
                  <input
                    type="number"
                    placeholder="Cost"
                    value={serviceCosts[serviceId] || ''} // Add this to maintain input values
                    className="w-1/2 p-2 border rounded-md"
                    onChange={(e) => handleServiceCostChange(serviceId, e.target.value)}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Buttons */}
      <div className="flex justify-end mt-4">
        <button
          className="bg-gray-300 px-4 py-2 rounded mr-2"
          onClick={() => {
            // Reset selected services and doctor details when closing the modal
            setSelectedServices([]);
            setSelectedDoctorDetails(null);
            handleCloseDoctorModal();
          }}
        >
          Cancel
        </button>

        <button
          className="bg-green-500 text-white px-4 py-2 rounded"
          onClick={handleSubmitDoctor}
        >
          {doctorEditMode ? networkLoading ? <ButtonLoader/>: 'Update' : networkLoading ? <ButtonLoader/>: 'Add'}
        </button>
      </div>
    </div>
  </div>
)}



{editModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
    <div className="bg-white p-8 rounded-lg shadow-lg w-[900px] max-h-[90vh] overflow-y-auto">
      <h3 className="text-lg font-semibold mb-4">Edit Facility</h3>

      {/* Hospital Details (Two-column layout) */}
      <div className="grid grid-cols-3 gap-6">
        <div>
          <label className="block text-sm font-medium">Facility Name</label>
          <input
            type="text"
            name="hospitalName"
            placeholder="Facility Name"
            value={editFormData.hospitalName}
            onChange={handleEditChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Address 1</label>
          <input
            type="text"
            name="hospitalAddress1"
            placeholder="Address 2"
            value={editFormData.hospitalAddress1}
            onChange={handleEditChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Address 2</label>
          <input
            type="text"
            name="hospitalAddress2"
            placeholder="Address 2"
            value={editFormData.hospitalAddress2}
            onChange={handleEditChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">City</label>
          <input
            type="text"
            name="hospitalCity"
            placeholder="City"
            value={editFormData.hospitalCity}
            onChange={handleEditChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">State</label>
          <input
            type="text"
            name="hospitalState"
            placeholder="State"
            value={editFormData.hospitalState}
            onChange={handleEditChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Zip</label>
          <input
            type="text"
            name="hospitalZip"
            placeholder="Zip"
            value={editFormData.hospitalZip}
            onChange={handleEditChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Email</label>
          <input
            type="email"
            name="hospitalEmail"
            placeholder="Email"
            value={editFormData.hospitalEmail}
            onChange={handleEditChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Phone Number</label>
          <input
            type="text"
            name="hospitalPhone"
            placeholder="Phone"
            value={editFormData.hospitalPhone}
            onChange={(e) => handlePhoneChange(e, setEditFormData, 'hospitalPhone')}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">Fax</label>
          <input
            type="text"
            name="hospitalFax"
            placeholder="Fax"
            value={editFormData.hospitalFax}
            onChange={handleEditChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium">NPI#</label>
          <input
            type="text"
            name="hospitalNPI"
            placeholder="NPI#"
            value={editFormData.hospitalNPI}
            onChange={handleEditChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
      </div>

      {/* Contact Sections (Two Columns) */}
      <div className="grid grid-cols-2 gap-6 mt-6">
        {/* Main Contact */}
        <div>
          <h3 className="text-md font-semibold mb-2">Main Contact</h3>
          <div className="space-y-2">
            <label className="block text-sm font-medium">First Name</label>
            <input
              type="text"
              name="hospitalMainContactFirstName"
              placeholder="First Name"
              value={editFormData.hospitalMainContactFirstName}
              onChange={handleEditChange}
              className="w-full p-2 border rounded-md"
            />
            <label className="block text-sm font-medium">Last Name</label>
            <input
              type="text"
              name="hospitalMainContactLastName"
              placeholder="Last Name"
              value={editFormData.hospitalMainContactLastName}
              onChange={handleEditChange}
              className="w-full p-2 border rounded-md"
            />
            <label className="block text-sm font-medium">Email</label>
            <input
              type="text"
              name="hospitalMainContactEmail"
              placeholder="Email"
              value={editFormData.hospitalMainContactEmail}
              onChange={handleEditChange}
              className="w-full p-2 border rounded-md"
            />
            <label className="block text-sm font-medium">Phone</label>
            <input
              type="text"
              name="hospitalMainContactPhone"
              placeholder="Phone"
              value={editFormData.hospitalMainContactPhone}
              onChange={(e) => handlePhoneChange(e, setEditFormData, 'hospitalMainContactPhone')}
              className="w-full p-2 border rounded-md"
            />
          </div>
        </div>

        {/* Accounting Contact */}
        <div>
          <h3 className="text-md font-semibold mb-2">Accounting Contact</h3>
          <div className="space-y-2">
            <label className="block text-sm font-medium">First Name</label>
            <input
              type="text"
              name="hospitalAccountingContactFirstName"
              placeholder="First Name"
              value={editFormData.hospitalAccountingContactFirstName}
              onChange={handleEditChange}
              className="w-full p-2 border rounded-md"
            />
            <label className="block text-sm font-medium">Last Name</label>
            <input
              type="text"
              name="hospitalAccountingContactLastName"
              placeholder="Last Name"
              value={editFormData.hospitalAccountingContactLastName}
              onChange={handleEditChange}
              className="w-full p-2 border rounded-md"
            />
            <label className="block text-sm font-medium">Email</label>
            <input
              type="text"
              name="hospitalAccountingContactEmail"
              placeholder="Email"
              value={editFormData.hospitalAccountingContactEmail}
              onChange={handleEditChange}
              className="w-full p-2 border rounded-md"
            />
            <label className="block text-sm font-medium">Phone</label>
            <input
              type="text"
              name="hospitalAccountingContactPhone"
              placeholder="Phone"
              value={editFormData.hospitalAccountingContactPhone}
              onChange={(e) => handlePhoneChange(e, setEditFormData, 'hospitalAccountingContactPhone')}
              className="w-full p-2 border rounded-md"
            />
          </div>
        </div>
      </div>
      {/* Buttons */}
      <div className="flex justify-end gap-2 mt-6">
        <button
          onClick={() => setEditModalOpen(false)}
          className="px-4 py-2 bg-gray-300 rounded-md"
        >
          Cancel
        </button>
        <button
          onClick={handleSaveEdit}
          className="px-4 py-2 bg-blue-600 text-white rounded-md"
        >
          {networkLoading? <ButtonLoader/>: "Save"}
        </button>
      </div>
    </div>
  </div>
)}

{showModal && (
  <div className="fixed inset-0 bg-opacity-40 backdrop-blur-md flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[80vh] overflow-y-auto">
      <h2 className="text-xl font-semibold mb-4 bg-gray-700 text-white p-3 rounded-md shadow-md text-center">
        Add New Facility
      </h2>

      {/* Hospital Details Input Fields */}
      <div className="grid grid-cols-3 gap-4">
        {[
          "hospitalName",
          "hospitalAddress1",
          "hospitalAddress2",
          "hospitalCity",
          "hospitalState",
          "hospitalZip",
          "hospitalEmail",
          "hospitalPhone",
          "hospitalFax",
          "hospitalNPI",
        ].map((field) => (
          <div key={field}>
            <label className="block font-semibold">
              {field.replace(/hospital|([A-Z])/g, " $1").trim()}
            </label>
            <input
              type={field.includes("Email") ? "email" : "text"}
              placeholder={field.replace(/hospital|([A-Z])/g, " $1").trim()}
              className="w-full p-2 border rounded"
              value={newHospital[field] || ""}
              onChange={(e) => {
                if (field === "hospitalPhone" || field === "hospitalFax") {
                  handlePhoneChange(e, setNewHospital, field);
                } else {
                  setNewHospital({ ...newHospital, [field]: e.target.value });
                }
              }}
            />
            {errors[field] && <p className="text-red-500 text-sm">{errors[field]}</p>}
          </div>
        ))}
      </div>

      {/* Contact Information Sections */}
      <div className="grid grid-cols-2 gap-8 mt-6">
        {["MainContact", "AccountingContact"].map((contactType) => (
          <div key={contactType} className="space-y-2">
            <h3 className={`text-md font-semibold ${
              contactType === "MainContact" ? "bg-gray-600 text-white px-2 py-1 rounded-md" : ""
            }`}>
              {contactType.replace("Contact", " Contact")}
            </h3>
            {["First Name", "Last Name", "Email", "Phone"].map((field) => {
              const fieldName = `hospital${contactType}${field.replace(" ", "")}`;
              return (
                <div key={fieldName}>
                  <label className="block font-semibold">{field}</label>
                  <input
                    type={field === "Email" ? "email" : "text"}
                    placeholder={field}
                    className="w-full p-2 border rounded"
                    value={newHospital[fieldName] || ""}
                    onChange={(e) => {
                      if (field === "Phone") {
                        handlePhoneChange(e, setNewHospital, fieldName);
                      } else {
                        setNewHospital({ ...newHospital, [fieldName]: e.target.value });
                      }
                    }}
                  />
                  {errors[fieldName] && <p className="text-red-500 text-sm">{errors[fieldName]}</p>}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Buttons */}
      <div className="flex justify-end mt-4">
        <button
          className="bg-gray-300 px-4 py-2 rounded mr-2"
          onClick={() => {
            setShowModal(false);
            setErrors({}); // Reset errors when closing the modal
          }}
        >
          Cancel
        </button>

        <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={handleSubmitHospital}>
          {networkLoading ? <ButtonLoader/>:'Add'}
        </button>
      </div>
    </div>
  </div>
)}
  
      </div>
    );
  }

export default HospitalManagement;